export default {
  methods: {
    removeDuplicates(dataArray, key) {
      return [...new Map(dataArray.map((item) => [item[key], item])).values()];
    },
  },
};
